<div class="container mt-5">
    <div class="row mt-5">
        <div class="col-md-4 offset-md-4 col-sm-6 offset-sm-3 text-center mt-5">
            <p class="h3 mb-4">
             Invalid Request
            </p>
            <p class="text-muted textBody--md u-marginTop--reset u-marginBottom--large">
                The supplied request was not valid,  Please contact your system administrator.</p>
        </div>
    </div>
    <div class="row mt-5">
        <div class="col-12 text-center">
            <small>Need assistance? | <a href="mailto:gtls@deloitte.com?subject=General Enquiry">Contact us</a></small>
        </div>
    </div>
</div>